export { default } from "./RatingBadgeView";
